<template>
	<!--内容-->
	<div class="bodyboxinvention cursorstyle">
		<div class="PatentNature">
			<div style="display: flex;">
				<div class="title"><span style="color: red;">*</span>商标名称：</div>
				<div class="inputbox">
					<el-input v-model="formdata.name" :disabled="this.$route.query.mark == 'see' ? true : false" placeholder="请输入内容"></el-input>
				</div>
			</div>
		</div>
		<div class="technology">
			<div class="title"><span style="color: red;">*</span>商标注册申请书：</div>
			<div class="inputbox" v-if="mark != 'see'">
				请上传文件
			</div>
			<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
				:on-change="(file, fileList)=>{return handleChange(file, fileList, 'apply_file')}"
				:on-success="(response)=>{return handleAvatarSuccess(response, 'apply_file')}"
				:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'apply_file')}" :file-list="apply_file"
				:http-request="(response)=>{return httpRequest(response,'apply_file')}">
				<div class="enclosure" v-if="mark != 'see'">
					上传附件
					<img src="@/assets/img/文件.png" alt="">
				</div>
<!--				<div class="enclosure1" v-if="mark != 'see'">-->
<!--					<span>下载模板️</span>-->
<!--					<i class="el-icon-download"></i>-->
<!--				</div>-->
			</el-upload>
		</div>
		<div class="business">
			<div>
				<div class="title"><span style="color: red;">*</span>商标图样上传：</div>
				<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" :action="GLOBAL.uploadBASE_URL" list-type="picture-card"
					:on-change="(file, fileList)=>{return handleChange(file, fileList, 'sample_file')}"
					:on-success="(response)=>{return handleAvatarSuccess(response, 'sample_file')}"
					:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'sample_file')}"
					:file-list="sample_file" :http-request="(response)=>{return httpRequest(response,'sample_file')}">
					<i slot="default" class="el-icon-plus"></i>
				</el-upload>
			</div>
		</div>

		<div class="business" v-if="templat==1">
			<div>
				<div class="title"><span style="color: red;">*</span>身份证复印件：</div>

				<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" :action="GLOBAL.uploadBASE_URL" list-type="picture-card"
					:on-change="(file, fileList)=>{return handleChange(file, fileList, 'photo')}"
					:on-success="(response)=>{return handleAvatarSuccess(response, 'photo')}"
					:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'photo')}" :file-list="photo"
					:http-request="(response)=>{return httpRequest(response,'photo')}">
					<i slot="default" class="el-icon-plus"></i>
				</el-upload>
			</div>
		</div>

		<div class="business" v-if="templat==1">
			<div>
				<div class="title"><span style="color: red;">*</span>个体户营业执照:</div>
				<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" :action="GLOBAL.uploadBASE_URL" list-type="picture-card"
					:on-change="(file, fileList)=>{return handleChange(file, fileList, 'business_license')}"
					:on-success="(response)=>{return handleAvatarSuccess(response, 'business_license')}"
					:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'business_license')}"
					:file-list="business_license"
					:http-request="(response)=>{return httpRequest(response,'business_license')}">
					<i slot="default" class="el-icon-plus"></i>
				</el-upload>
			</div>
		</div>


		<div class="business" v-if="templat==2">
			<div>
				<div class="title"><span style="color: red;">*</span>申请人主体资格证明文件复印件：</div>

				<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" :action="GLOBAL.uploadBASE_URL" list-type="picture-card"
					:on-change="(file, fileList)=>{return handleChange(file, fileList, 'business_license')}"
					:on-success="(response)=>{return handleAvatarSuccess(response, 'business_license')}"
					:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'business_license')}"
					:file-list="business_license"
					:http-request="(response)=>{return httpRequest(response,'business_license')}">
					<i slot="default" class="el-icon-plus"></i>
				</el-upload>
			</div>
		</div>
		<div class="technology" v-if="templat==2">
			<div class="title"><span style="color: red;">*</span>声明文件：</div>
			<div class="inputbox" v-if="mark != 'see'">
				请上传文件
			</div>

			<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" class="upload-demo" :action="this.GLOBAL.uploadBASE_URL"
				:on-change="(file, fileList)=>{return handleChange(file, fileList, 'declare_file')}"
				:on-success="(response)=>{return handleAvatarSuccess(response, 'declare_file')}"
				:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'declare_file')}"
				:file-list="declare_file" :http-request="(response)=>{return httpRequest(response,'declare_file')}">
				<div class="enclosure" v-if="mark != 'see'">
					上传附件
					<img src="@/assets/img/文件.png" alt="">
				</div>
<!--				<div class="enclosure1" v-if=" mark != 'see'">-->
<!--					<span>下载模板️</span>-->
<!--					<i class="el-icon-download"></i>-->
<!--				</div>-->
			</el-upload>
		</div>



		<div class="technology">
			<div class="title">技术交底书：</div>
			<div class="">
				<div style="margin-bottom: 3px;">
					<el-radio-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.tech_file_type">
						<el-radio :label="1">递交纸质版</el-radio>
						<el-radio :label="2">递交电子版</el-radio>
					</el-radio-group>
				</div>

				<div style="display: flex;" v-if="formdata.tech_file_type == 2">
					<div class="inputbox" v-if="mark != 'see'">
						请上传文件
					</div>
					<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
						:on-change="(file, fileList)=>{return handleChange(file, fileList, 'tech_file')}"
						:on-success="(response)=>{return handleAvatarSuccess(response, 'tech_file')}"
						:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'tech_file')}"
						:file-list="tech_file"
						:http-request="(response)=>{return httpRequest(response,'tech_file')}">
						<div class="enclosure" v-if="mark != 'see'">
							上传附件
							<img src="@/assets/img/文件.png" alt="">
						</div>
					</el-upload>
          <div class="enclosure1" v-if="mark != 'see'">
            <span><a :href="GLOBAL.jiShuJiaoDi" download="技术交底书.docx">下载模板️</a></span>
            <i class="el-icon-download"></i>
<!--            <span style="line-height: 28px; color: red; margin-left: 5px;">（注：申请外观设计专利无需上传，以word形式上传100字左右的专利说明即可）</span>-->

          </div>
				</div>
			</div>
		</div>
    <!--    职务和高级职务不上传承诺书-->
    <div class="technology" v-if="this.userObj.info().nature != 3 &&this.userObj.info().nature != 0">
			<div class="title">承诺书：</div>
			<div class="inputbox" v-if="mark != 'see'">
				请上传文件
			</div>
			<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
				:on-change="(file, fileList)=>{return handleChange(file, fileList, 'promise_file')}"
				:on-success="(response)=>{return handleAvatarSuccess(response, 'promise_file')}"
				:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'promise_file')}"
				:file-list="promise_file" :http-request="(response)=>{return httpRequest(response,'promise_file')}">
				<div class="enclosure"  v-if="mark != 'see'">
					上传附件
					<img src="@/assets/img/文件.png" alt="">
				</div>
			</el-upload>
<!--      <div class="enclosure1" v-if="mark != 'see'">-->
<!--        <span @click="promise_fileDownload">下载模板️</span>-->
<!--        <i class="el-icon-download"></i>-->
<!--      </div>-->
      <div class="enclosure1" v-if="this.$route.query.mark != 'see'">
        <span><a :href="GLOBAL.qiTaJiGochengNuo(this.userObj.info().nature)" download="技术交底书.docx">下载模板️</a></span>
        <i class="el-icon-download"></i>
      </div>
		</div>

		<div class="technology">
			<div>是否进行过知识产权保护：</div>
			<div class="">
				<el-radio-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.is_ip_protected">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</div>
		</div>
	
		<div class="technology" v-if="formdata.is_ip_protected === 1">
			<div>已保护知识产权类型：</div>
			<div class="">
				<el-checkbox-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="protected_ip_type" @change="handleCheckAllChange">
					<el-checkbox label="1">专利</el-checkbox>
					<el-checkbox label="2">商标</el-checkbox>
					<el-checkbox label="3">软件著作权（版权）</el-checkbox>
					<el-checkbox label="4">其它</el-checkbox>
				</el-checkbox-group>
			</div>
			<div class="research_project_titlebox" style="margin-left: 3vw;">
				<input type="text" :disabled="this.$route.query.mark == 'see' ? true : false" placeholder="输入知识产权类型" v-model="formdata.protected_ip_desc">
			</div>
			<span style="line-height: 28px; color: red; margin-left: 5px;">(注：可多选)</span>
		</div>
		<div class="technology" >
			<div class="title">知识产权方式：</div>
			<div class="">
				<el-radio-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.ip_mode">
					<el-radio :label="1">保护</el-radio>
					<el-radio :label="2">转化</el-radio>
					<el-radio :label="3">保护+转化</el-radio>
				</el-radio-group>
			</div>
		</div>
		<div class="technology" v-if="formdata.ip_mode == 2|| formdata.ip_mode == 3">
			<div class="title">收益比例确认书：</div>
			<div class="inputbox" v-if="mark != 'see'">
				请上传文件
			</div>
			<el-upload class="upload-demo" :action="GLOBAL.uploadBASE_URL"
				:on-change="(file, fileList)=>{return handleChange(file, fileList, 'proxy_file')}"
				:on-success="(response)=>{return handleAvatarSuccess(response, 'proxy_file')}"
				:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'proxy_file')}"
				:file-list="proxy_file"
				:http-request="(response)=>{return httpRequest(response,'proxy_file')}">
				<div class="enclosure" v-if="mark != 'see'">
					上传附件
					<img src="@/assets/img/文件.png" alt="">
				</div>
			</el-upload>
      <div class="enclosure1" v-if="mark != 'see'">
        <span><a :href="GLOBAL.shouYiBiLI" download="收益比例确认书">下载模板</a></span>
        <i class="el-icon-download"></i>
      </div>
		</div>
    <div class="technology" v-if="formdata.ip_mode == 2|| formdata.ip_mode == 3">
      <div class="title">公证书：</div>
      <div class="inputbox" v-if="mark != 'see'">
        请上传文件
      </div>
      <el-upload :disabled="this.$route.query.mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
                 :on-change="(file, fileList)=>{return handleChange(file, fileList, 'notarization_file')}"
                 :on-success="(response)=>{return handleAvatarSuccess(response, 'notarization_file')}"
                 :on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'notarization_file')}"
                 :file-list="notarization_file"
                 :http-request="(response)=>{return httpRequest(response,'notarization_file')}">
        <div class="enclosure" v-if="mark != 'see'">
          上传附件
          <img src="@/assets/img/文件.png" alt="">
        </div>
<!--        <div class="enclosure1" v-if="mark != 'see'">-->
<!--          <span>下载模板️</span>-->
<!--          <i class="el-icon-download"></i>-->
<!--        </div>-->
        <span style="line-height: 28px; color: red; margin-left: 5px;">（注：请将“收益比例确认书”公证后进行上传）</span>


      </el-upload>
    </div>
		<div class="technology">
			<div class="title">科研经费支持：</div>
			<div class="">
				<el-radio-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.is_research_funds_support">
					<el-radio :label="0">是</el-radio>
					<el-radio :label="1">否</el-radio>
				</el-radio-group>
			</div>
			<div class="research_project_titlebox" style="margin-left: 3vw;">
				<input type="text" :disabled="this.$route.query.mark == 'see' ? true : false" placeholder="输入科研课题/项目名称" v-model="formdata.research_project_title">
			</div>
		</div>
		<div class="technology">
			<div class="title">其他附件：</div>
			<div class="inputbox" v-if="mark != 'see'">
				请上传文件
			</div>
			<el-upload :disabled="this.$route.query.mark == 'see' ? true : false" class="upload-demo" :action="GLOBAL.uploadBASE_URL"
				:on-change="(file, fileList)=>{return handleChange(file, fileList, 'other_file')}"
				:on-success="(response)=>{return handleAvatarSuccess(response, 'other_file')}"
				:on-remove="(file,fileList)=>{return handleRemove(file,fileList, 'other_file')}" :file-list="other_file"
				:http-request="(response)=>{return httpRequest(response,'other_file')}">
				<div class="enclosure" v-if="mark != 'see'">
					上传附件
					<img src="@/assets/img/文件.png" alt="">
				</div>


			</el-upload>
			<span style="line-height: 28px; color: red; margin-left: 5px;">(注：可上传word文字介绍，视频简介，ppt，PDF，不限格式)</span>
		</div>

    <div v-if="formdata.create_type == 2||this.$route.query.create_type == 2">
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">申请号：</div>
          <div class="inputbox">
            <el-input :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.apply_serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">商标申请日：</div>
          <div class="inputbox">
            <el-date-picker :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.apply_time" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="technology">
        <div class="title">是否授权：</div>
        <div class="">
          <el-radio-group :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.is_authenticated">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">授权商标名称：</div>
          <div class="inputbox">
            <el-input :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.authenticated_name" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">商标权号：</div>
          <div class="inputbox">
            <el-input :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">证书号：</div>
          <div class="inputbox">
            <el-input :disabled="this.$route.query.mark == 'see' ? true : false"  v-model="formdata.certificate_serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">授权公告号：</div>
          <div class="inputbox">
            <el-input :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.authenticated_serial_no" placeholder="请输入内容"></el-input>
          </div>
        </div>
      </div>

      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">授权公告日：</div>
          <div class="inputbox">
            <el-date-picker :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.authenticated_time" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                            type="date" placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="PatentNature">
        <div style="display: flex;">
          <div class="title">过期日期：</div>
          <div class="inputbox">
            <el-date-picker :disabled="this.$route.query.mark == 'see' ? true : false" v-model="formdata.expire_time" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date"
                            placeholder="选择日期">
            </el-date-picker>
          </div>
        </div>
      </div>
    </div>

		<!-- <div class="tjbtn" v-if="!this.$route.query.mark">
			<span @click="SubmitBtn('add')">提交</span>
		</div>
		<div class="tjbtn" v-if="this.$route.query.mark=='edit'">
			<span @click="SubmitBtn('edit')">提交</span>
		</div> -->



		<div class="btnbox cursorstyleObjBtn" >
			<div class="bcbtn" v-if="!this.$route.query.mark && this.TrademarkIDlength == null" @click="SubmitBtn('add','Trademark')">
				<span >保存</span>
			</div>
			<div class="tjbtn cursorstyleObjBtn" v-if="!this.$route.query.mark && this.TrademarkIDlength == null" @click="SubmitBtn('add')">
				<span >提交</span>
			</div>
			<!-- <div v-if="!this.$route.query.ids" style="display: inline-block;"> -->
				<div class="bcbtn cursorstyleObjBtn" v-if="this.$route.query.mark=='edit'||this.TrademarkIDlength>0 " @click="SubmitBtn('edit','Trademark')">
					<span >保存</span>
				</div>
			<!-- </div> -->
			
			<div class="tjbtn cursorstyleObjBtn" v-if="this.$route.query.mark=='edit'||this.TrademarkIDlength>0"  @click="SubmitBtn('edit')">
				<span>提交</span>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		upload,
		AddTrademarkInterface,
		GetObjTrademarkInterface,
		modifyTrademarkInterface
	} from '@/api/ApplicationManagement.js'
	export default {
		props: {
			templat: {}
		},
		data() {
			return {
			  mark:'',
				// 申请书url
				apply_file: [],
				// 图样url
				sample_file: [],
				// 代理委托书url
				proxy_file: [],
        //公正书
        notarization_file:[],
				// 营业执照url，企业证明文件url
				business_license: [],
				// 证明文件url
				declare_file: [],
				// 技术交底书url
				tech_file: [],
				// 身份证照片URL
				photo: [],
				// 承诺书
				promise_file: [],
				// 其他附件 other_file
				other_file: [],
				// 类型
				protected_ip_type: [],
				formdata: {
					// 名称
					name: "",
					// 商标性质：1:个人 2:法人
					nature: 1,
					// 申请书url
					apply_file: '',
					// 图样url
					sample_file: '',
					// 代理委托书url
					proxy_file: '',
          //公正书
          notarization_file:'',
					// 营业执照url，企业证明文件url
					business_license: '',
					// 证明文件url
					declare_file: '',
					// // 技术交底书url
					// tech_file: '',
					// // 身份证照片URL
					// photo: '',
					// // 承诺书
					// promise_file: '',
					// // 知识产权方式
					// "ip_mode": '',
					// // 是否进行过知识产权保护
					// is_ip_protected: '',
					// // 已保护知识产权类型
					// "protected_ip_type": '',
					// // 已保护知识产权类型其他说明
					// "protected_ip_desc": '',
					// // 经费
					// "is_research_funds_support": '',
					// // 科研项目名称
					// "research_project_title": '',
					// // 技术交底书性质 1:纸质版 2:电子版
					// "tech_file_type":null,
					// // 其他附件
					// other_file: ''
				},
				TrademarkIDlength: null
			}
		},
		watch: {
			templat: {
				deep: true, //深度监听设置为 true
				handler: function(newV, oldV) {
					this.formdata.nature = newV
				}
			}
		},
		created() {
			
			// let mark = this.$route.query.mark
			// // 查看
			// if (mark == "see" || mark == "edit") {
			// 	this.GetlistPatent()
			// }
			
			if (localStorage.getItem('TrademarkID')) {
				this.TrademarkIDlength = localStorage.getItem('TrademarkID').length
			}
			let mark = this.$route.query.mark
			// 查看
			if (mark == "see" || mark == "edit" || localStorage.getItem('TrademarkID')) {
				if(this.$route.query.ids){
					this.GetlistPatent(this.$route.query.ids)
				}
				else if(localStorage.getItem('TrademarkID').length > 0) {
					this.GetlistPatent(localStorage.getItem('TrademarkID'))
				}
			}
			
			
			
			
		},
		mounted() {
      this.mark = this.$route.query.mark
      if (this.$route.query.create_type == 2) {
        this.formdata.create_type = 2
      } else {
        this.formdata.create_type = 1
      }
		},
		methods: {
      //下载承诺书
      promise_fileDownload(){
        this.$alert('<strong><a href="./export/shouYiBiLi.docx" download="下载模板1️.docx">下载模板1️</a><br/><a href="./export/shouYiBiLi.docx" download="下载模板2️.docx">下载模板2️</a> </strong>', '承诺书模版', {
          dangerouslyUseHTMLString: true
        });
      },
			//获取详情
			async GetlistPatent(value) {
				let obj = {
					id: value
				}
				let res = await GetObjTrademarkInterface(obj)
				if (res.code === "00000") {
					this.formdata = res.data
					this.$emit("dataNature", res.data.nature)
					this.$delete(this.formdata, 'status')
					this.$delete(this.formdata, 'status_txt')
					this.$delete(this.formdata, 'create_time')
					this.$delete(this.formdata, 'nature')
					this.$delete(this.formdata, 'pass_time')
					// // 申请书url
					// apply_file: [],
					if(res.data.apply_file !=''){
						this.apply_file = res.data.apply_file
					}
					
					// // 图样url
					// sample_file: [],
					if(res.data.sample_file!=''){
						this.sample_file = res.data.sample_file
					}
					
					// // 代理委托书url
					// proxy_file: [],
					if(res.data.proxy_file!=''){
						this.proxy_file = res.data.proxy_file
					}
          //公正书
          // notarization_file:[],
          if(res.data.notarization_file!=''){
            this.notarization_file = res.data.notarization_file
          }
					// // 营业执照url，企业证明文件url
					// business_license: [],
					if(res.data.business_license!=''){
						this.business_license = res.data.business_license
					}
					
					// // 证明文件url
					// declare_file: [],
					if(res.data.declare_file!=''){
						this.declare_file = res.data.declare_file
					}
					
					// // 技术交底书url
					// tech_file: [],
					if(res.data.tech_file!=''){
						this.tech_file = res.data.tech_file
					}
					// // 身份证照片URL
					// photo: [],
					if(res.data.photo!=''){
						this.photo = res.data.photo
					}
					// 承诺书 promise_file
					if(res.data.promise_file!=''){
						this.promise_file = res.data.promise_file
					}
					// 其他附件 other_file
					if(res.data.other_file!=''){
						this.other_file = res.data.other_file
					}
					
					// 保护类型
					if(res.data.protected_ip_type){
						this.protected_ip_type = res.data.protected_ip_type.split(',')
					}
				}
			},
			httpRequest(param, type) {
				let fileObj = param.file // 相当于input里取得的files
				let fd = new FormData() // FormData 对象
				fd.append('files', fileObj) // 文件对象
				this.uploadInterface(fd, type, fileObj)
			},
			handleChange(file, fileList, type) {
			},
			// 上传成功
			handleAvatarSuccess(res, type) {
			},
			// 上传删除
			handleRemove(file, fileList, type) {
				// 申请书url apply_file: [],
				if (type == 'apply_file') {
					this.apply_file = fileList
				}
				// 图样url sample_file:[],
				else if (type == 'sample_file') {
					this.sample_file = fileList
				}
				// 代理委托书url proxy_file:[],
				else if (type == 'proxy_file') {
					this.proxy_file = fileList
				}
            //公正书
            // notarization_file:[],
        else if (type == 'notarization_file') {
          this.notarization_file = fileList
        }
				// 营业执照url，企业证明文件url business_license:[],
				else if (type == 'business_license') {
					this.business_license = fileList
				}
				// 证明文件url declare_file:[],
				else if (type == 'declare_file') {
					this.declare_file = fileList
				}
				// 技术交底书url tech_file: [],
				else if (type == 'tech_file') {
					this.tech_file = fileList
				}
				// 身份证照片URL photo: [],
				else if (type == 'photo') {
					this.photo = fileList
				}
				// 承诺书 promise_file
				else if (type == 'promise_file') {
					this.promise_file = fileList
				}
				// 其他附件 other_file
				else if (type == 'other_file') {
					this.other_file = fileList
				}

			},
			//上传
			async uploadInterface(obj, type, fileObj) {
				let res = await upload(obj)
				if (type == 'apply_file') {
					this.apply_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 图样url sample_file:[],
				else if (type == 'sample_file') {
					this.sample_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 代理委托书url proxy_file:[],
				else if (type == 'proxy_file') {
					this.proxy_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
            //公正书
            // notarization_file:[],
        else if (type == 'notarization_file') {
          this.notarization_file.push({
            url: res.data.url,
            name: fileObj.name
          })
        }
				// 营业执照url，企业证明文件url business_license:[],
				else if (type == 'business_license') {
					this.business_license.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 证明文件url declare_file:[],
				else if (type == 'declare_file') {
					this.declare_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 技术交底书url tech_file: [],
				else if (type == 'tech_file') {
					this.tech_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 身份证照片URL photo: [],
				else if (type == 'photo') {
					this.photo.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 承诺书 promise_file
				else if (type == 'promise_file') {
					this.promise_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
				// 其他附件 other_file
				else if (type == 'other_file') {
					this.other_file.push({
						url: res.data.url,
						name: fileObj.name
					})
				}
			},
			SubmitBtn(value, bc) {
        this.formdata.nature = this.userObj.info().nature
				// // 客户没有选择时就删除当前字段// 是否进行过知识产权保护
				// if(this.formdata.is_ip_protected == ''){
				// 	this.$delete(this.formdata, 'is_ip_protected')
				// }
				// // 客户没有选择时就删除当前字段 知识产权方式
				// if(this.formdata.ip_mode == ''){
				// 	this.$delete(this.formdata, 'ip_mode')
				// }
				// // 客户没有选择时就删除当前字段 技术交底书
				// if(this.formdata.tech_file_type == ''){
				// 	this.$delete(this.formdata, 'tech_file_type')
				// }

					if (this.formdata.name.length == 0) {
						this.$message.error('请输入商标名称')
						return
					}
					if (this.apply_file.length == 0) {
						this.$message.error('请上传商标注册申请书')
						return
					}
					if (this.sample_file.length == 0) {
						this.$message.error('请上传商标图样上传')
						return
					}
					// if (this.proxy_file.length == 0) {
					// 	this.$message.error('请上传商标代理委托书')
					// 	return
					// }

					if (this.templat == 1) {

            if (this.photo.length == 0) {
              this.$message.error('身份证复印件')
              return
            }
            if (this.business_license.length == 0) {
              this.$message.error('个体户营业执照')
              return
            }
					
					} else if (this.templat == 2) {
            if (this.business_license.length == 0) {
              this.$message.error('申请人主体资格证明文件复印件')
              return
            }


					}


        // // // 技术交底书性质 1:纸质版 2:电子版
        // // "tech_file_type": null,
        // if (this.formdata.tech_file_type == null) {
        //   this.$message({
        //     type: "error",
        //     message: "请选择技术交底书",
        //   });
        //   return;
        // }
        // if (this.formdata.tech_file_type == 2 && this.tech_file.length == 0) {
        //   this.$message({
        //     type: "error",
        //     message: "请上传技术交底书",
        //   });
        //   return;
        // }
        //
        // //     // 承诺书
        // //     "promise_file": '',
        // // 承诺书 promise_file
        // if (this.promise_file.length == 0) {
        //   this.$message({
        //     type: "error",
        //     message: "请上传承诺书",
        //   });
        //   return;
        // }
        // //     // 是否进行过知识产权保护
        // //     "is_ip_protected": '',
        // if (this.formdata.is_ip_protected.length == 0) {
        //   this.$message({
        //     type: "error",
        //     message: "请选择是否进行过知识产权保护",
        //   });
        //   return;
        // }
        // if(this.protected_ip_type.length<=0 && this.formdata.is_ip_protected == 1){
        //   this.$message({
        //     type: "error",
        //     message: "请选择已保护知识产权类型",
        //   });
        //   return;
        // }
        // //     // 知识产权方式
        // //     "ip_mode": '',
        // if (this.formdata.ip_mode.length == 0) {
        //   this.$message({
        //     type: "error",
        //     message: "请选择知识产权方式",
        //   });
        //   return;
        // }
        // if ((this.formdata.ip_mode== 2 ||this.formdata.ip_mode== 3) && this.proxy_file.length==0) {
        //   this.$message({
        //     type: "error",
        //     message: "请上传收益比例确认书",
        //   });
        //   return;
        // }
        // //公正书
        // // notarization_file:[],
        // if ((this.formdata.ip_mode== 2 ||this.formdata.ip_mode== 3) && this.notarization_file.length==0) {
        //   this.$message({
        //     type: "error",
        //     message: "请上传公正书",
        //   });
        //   return;
        // }
        // //     // 经费
        // //     "is_research_funds_support": '',
        // if (this.formdata.is_research_funds_support.length == 0) {
        //   this.$message({
        //     type: "error",
        //     message: "请选择科研经费支持",
        //   });
        //   return;
        // }
        // //     // 科研项目名称
        // //     "research_project_title": '',
        // if (this.formdata.is_research_funds_support== 0 &&this.formdata.research_project_title.length == 0) {
        //   this.$message({
        //     type: "error",
        //     message: "请输入科研项目名称",
        //   });
        //   return;
        // }




				// 申请书url
				this.formdata.apply_file = this.apply_file
				// 图样url
				this.formdata.sample_file = this.sample_file
				// 代理委托书url
				this.formdata.proxy_file = this.proxy_file
        //公正书
        // notarization_file:[],
        this.formdata.notarization_file = this.notarization_file

        // 营业执照url，企业证明文件url
				this.formdata.business_license = this.business_license
				// 证明文件url
				this.formdata.declare_file = this.declare_file
				// 技术交底书url
				this.formdata.tech_file = this.tech_file
				// 身份证照片URL
				this.formdata.photo = this.photo
				// 承诺书 promise_file
				this.formdata.promise_file = this.promise_file
				// 其他附件 other_file
				this.formdata.other_file = this.other_file
			// 已保护知识产权类型数组
				this.formdata.protected_ip_type = this.protected_ip_type.join(",")

				if (value == 'add') {
					// 添加
					this.addPatent(bc)
				} else if (value = 'edit') {
					// 修改
					this.modifyPatent(bc)
				}
			},
			//修改提交
			async modifyPatent(vlaue) {

				let obj = this.formdata
				if (vlaue == 'Trademark') {
					obj.status = 2
				} else {
					obj.status = 3
				}
				let res = await modifyTrademarkInterface(obj)
				if (res.code == "00000") {
					
					if (res.code == "00000") {
						if (vlaue == 'Trademark') {
							this.$message.success('保存成功')
							this.$router.push('./trademarkSeeMore')
						} else {
							localStorage.setItem('TrademarkID', '')
							this.$message.success('提交成功')
							this.$router.push('./trademarkSeeMore')
						}
					}
				}
			},

			//提交添加商标
			async addPatent(vlaue) {
				let obj = this.formdata
				if (vlaue == 'Trademark') {
					obj.status = 2
				} else {
					obj.status = 3
				}
				let res = await AddTrademarkInterface(obj)
				if (res.code == "00000") {
					if (vlaue == 'Trademark') {
						// localStorage.setItem('TrademarkID', res.data.id)
						localStorage.setItem('TrademarkID', '')
						this.$message.success('保存成功')
						this.$router.push('./trademarkSeeMore')
					} else {
						this.$message.success('提交成功')
						this.$router.push('./trademarkSeeMore')
					
					}
				}
			},
			// 已保护知识产权类型的数组
			handleCheckAllChange(val) {
				this.formdata.protected_ip_type = val
			},

		}
	}
</script>

<style scoped="scoped" lang="less">
	@import "../new_file.less";

	.title {
		// width: 8vw !important;
	}

	.bodyboxinvention {
		margin-top: -10px !important;
	}
</style>
